import { Button, Image, Text } from "@mantine/core";

/* eslint-disable @typescript-eslint/no-explicit-any */
interface summarizeProps {
  handleSummarize: (section: string) => void;
  section: string;
}
const BtnSummarize = ({ handleSummarize, section }: summarizeProps) => {
  return (
    <Button
      onClick={() => {
        handleSummarize(section);
      }}
      variant="outline"
      w={200}
      radius={20}
      bg={"white"}
    >
      <Image
        src="/assets/icons8-sparkle.gif"
        style={{
          height: 20,
          width: 20,
          marginHorizontal: 8
        }}
      />
      <Text c={"#000"} fz={18} ml={8}>
        Summarize
      </Text>
    </Button>
  );
};
export default BtnSummarize;
